module.exports = __webpack_public_path__ + "static/assets/c9dd72975cc161133dc267e735f7835f.png";